// extracted by mini-css-extract-plugin
export default {"lecturer__name":"Lecturer_lecturer__name__FwAz2"};